import { StopsState, StopsTypes } from './types';

const INITIAL_STATE: StopsState = {
  stopData: {
    id: '',
    name: '',
    startLat: 0,
    startLong: 0,
    endLat: 0,
    endLong: 0,
    covered: false,
    busBay: false,
    specialBusStop: false,
    radius: 0,
    type: 0,
    addressId: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
  },
  stopCreated: {
    id: '',
    name: '',
    startLat: 0,
    startLong: 0,
    endLat: 0,
    endLong: 0,
    covered: false,
    busBay: false,
    specialBusStop: false,
    radius: 0,
    type: 0,
    addressId: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
  },
  stopReports: [],
  stopsList: [],
  stopsListFull: [],
  itineraryStopsList: [],
  chipsList: [],
  selectedStartDate: new Date(),
  selectedEndDate: new Date(),
  totalCount: 0,
  loading: false,
  error: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Stops
const listStopsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  stopsList: INITIAL_STATE.stopsList,
});

const listStopsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  stopsList: action.payload.stopsList,
  totalCount: action.payload.totalCount,
});

const listStopsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// List Stops Full
const listStopsFullRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  stopsListFull: INITIAL_STATE.stopsListFull,
});

const listStopsFullSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  stopsListFull: action.payload.stopsListFull,
});

const listStopsFullFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// List Itinerary Stops
const listStopsItineraryRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  itineraryStopsList: INITIAL_STATE.itineraryStopsList,
});

const listStopsItinerarySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  itineraryStopsList: action.payload.itineraryStopsList,
  totalCount: action.payload.totalCount,
});

const listStopsItineraryFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  itineraryStopsList: INITIAL_STATE.itineraryStopsList,
});

// Filter Stops
const filterStopsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  stopsList: INITIAL_STATE.stopsList,
});

const filterStopsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  stopsList: action.payload.stopsList,
  totalCount: action.payload.totalCount,
});

const filterStopsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  stopsList: INITIAL_STATE.stopsList,
});

// Get Stop
const getStopRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  stopData: INITIAL_STATE.stopData,
});

const getStopSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  stopData: action.payload.stopData,
});

const getStopFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  stopData: INITIAL_STATE.stopData,
});

// Get Stop Reports
const getStopReportsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  stopReports: INITIAL_STATE.stopReports,
});

export const getStopReportsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  stopReports: action.payload.stopReports,
});

const getStopReportsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  stopReports: INITIAL_STATE.stopReports,
});

// Create Stop
const createStopRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  stopCreated: INITIAL_STATE.stopCreated,
});

const createStopSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  stopCreated: action.payload.stopCreated,
});

const createStopFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  stopCreated: INITIAL_STATE.stopCreated,
});

// Update Stop
const updateStopRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateStopSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  stopData: action.payload.stopData,
});

const updateStopFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Stop
const deleteStopRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteStopSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteStopFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// CASES GET CHIPS
const createChipsList = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  chipsList: action.payload.chipsList,
});

// CASES CLEAR CHIPS
const cleanChipsList = (state: any) => ({
  ...state,
  loading: false,
  error: false,
  chipsList: INITIAL_STATE.chipsList,
});

// SET SELECTED START DATE
const selectedStartDate = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  selectedStartDate: action.payload.selectedStartDate,
});

// CASES SELECTED END DATE
const selectedEndDate = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  selectedEndDate: action.payload.selectedEndDate,
});

const reducer = createReducer(INITIAL_STATE, {
  [StopsTypes.LIST_STOPS_REQUEST]: listStopsRequest,
  [StopsTypes.LIST_STOPS_SUCCESS]: listStopsSuccess,
  [StopsTypes.LIST_STOPS_FAILURE]: listStopsFailure,

  [StopsTypes.LIST_STOPS_FULL_REQUEST]: listStopsFullRequest,
  [StopsTypes.LIST_STOPS_FULL_SUCCESS]: listStopsFullSuccess,
  [StopsTypes.LIST_STOPS_FULL_FAILURE]: listStopsFullFailure,

  [StopsTypes.LIST_ITINERARY_STOPS_REQUEST]: listStopsItineraryRequest,
  [StopsTypes.LIST_ITINERARY_STOPS_SUCCESS]: listStopsItinerarySuccess,
  [StopsTypes.LIST_ITINERARY_STOPS_FAILURE]: listStopsItineraryFailure,

  [StopsTypes.FILTER_STOPS_REQUEST]: filterStopsRequest,
  [StopsTypes.FILTER_STOPS_SUCCESS]: filterStopsSuccess,
  [StopsTypes.FILTER_STOPS_FAILURE]: filterStopsFailure,

  [StopsTypes.GET_STOP_REQUEST]: getStopRequest,
  [StopsTypes.GET_STOP_SUCCESS]: getStopSuccess,
  [StopsTypes.GET_STOP_FAILURE]: getStopFailure,

  [StopsTypes.GET_STOP_REPORTS_REQUEST]: getStopReportsRequest,
  [StopsTypes.GET_STOP_REPORTS_SUCCESS]: getStopReportsSuccess,
  [StopsTypes.GET_STOP_REPORTS_FAILURE]: getStopReportsFailure,

  [StopsTypes.CREATE_STOP_REQUEST]: createStopRequest,
  [StopsTypes.CREATE_STOP_SUCCESS]: createStopSuccess,
  [StopsTypes.CREATE_STOP_FAILURE]: createStopFailure,

  [StopsTypes.UPDATE_STOP_REQUEST]: updateStopRequest,
  [StopsTypes.UPDATE_STOP_SUCCESS]: updateStopSuccess,
  [StopsTypes.UPDATE_STOP_FAILURE]: updateStopFailure,

  [StopsTypes.DELETE_STOP_REQUEST]: deleteStopRequest,
  [StopsTypes.DELETE_STOP_SUCCESS]: deleteStopSuccess,
  [StopsTypes.DELETE_STOP_FAILURE]: deleteStopFailure,

  [StopsTypes.CREATE_CHIPS_LIST]: createChipsList,
  [StopsTypes.CLEAN_CHIPS_LIST]: cleanChipsList,
  [StopsTypes.SET_SELECTED_START_DATE]: selectedStartDate,
  [StopsTypes.SET_SELECTED_END_DATE]: selectedEndDate,
});

export default reducer;
